import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '@environments/environment';
import { TenantConfigEntity } from '@api/tenant.model'

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private tenants = environment.tenants as TenantConfigEntity[]
  private tenant: TenantConfigEntity | null;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.tenant = this.extractTenantFromHost();
  }

  getAllTenants() {
    return this.tenants;
  }

  private extractTenantFromHost(): TenantConfigEntity | null {
    const host = this.document.location.hostname;
    return this.tenants.find((tenant: TenantConfigEntity) => tenant.url === host) ?? null;
  }

  getBffBaseUrl(): string | null {
    return this.tenant?.bffUrl ?? null;
  }

  getPolitiqueConfidentialite(): string | null {
    return this.tenant?.politiqueConfidentialite ?? null;
  }

  getTenant(): TenantConfigEntity | null {
    return this.tenant;
  }
}